<template>
  <!-- viewBox="0 0 16 16" -->
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.2998 1.5C7.41016 1.5 7.49983 1.58891 7.5 1.69922V5.5C7.50025 6.05207 7.94787 6.5 8.5 6.5H12.7998C12.9102 6.5 12.9998 6.58891 13 6.69922V13C12.9997 13.8282 12.3283 14.5 11.5 14.5H4.5C3.67173 14.5 3.00025 13.8282 3 13V3C3 2.17157 3.67157 1.5 4.5 1.5H7.2998ZM8 7.625C7.65482 7.625 7.375 7.90482 7.375 8.25V9.4248C7.37486 9.53514 7.28517 9.625 7.1748 9.625H6C5.65482 9.625 5.375 9.90482 5.375 10.25C5.37525 10.595 5.65498 10.875 6 10.875H7.1748C7.28516 10.875 7.37483 10.9639 7.375 11.0742V12.25C7.37525 12.595 7.65498 12.875 8 12.875C8.34502 12.875 8.62475 12.595 8.625 12.25V11.0742C8.62517 10.9639 8.71484 10.875 8.8252 10.875H10C10.345 10.875 10.6247 10.595 10.625 10.25C10.625 9.90482 10.3452 9.625 10 9.625H8.8252C8.71483 9.625 8.62514 9.53514 8.625 9.4248V8.25C8.625 7.90482 8.34518 7.625 8 7.625Z"
    fill="currentColor"
  />
  <path
    d="M9.00098 2.20605C9.00137 1.76093 9.53963 1.53781 9.85449 1.85254L12.1465 4.14648C12.4612 4.4615 12.2383 5 11.793 5H9.5C9.22387 4.99994 8.99993 4.77517 9 4.49902L9.00098 2.20605Z"
    fill="currentColor"
  />
</template>
